































import { Component, Vue } from "vue-property-decorator";
import { postNewPost } from "../../helpers/post-getter";
import { PostClass } from "../../types";

@Component
export default class NewPost extends Vue {
  new_post = {
    content: "",
    image_url: "",
  };

  error = "";

  get user() {
    return this.$store.state.user;
  }

  createPost(): void {
    postNewPost(this.new_post.content, this.user.id, this.new_post.image_url)
      .then((post) => {
        this.$emit(
          "post-created",
          new PostClass(
            post.created_post.id,
            this.new_post.content,
            this.user.username,
            new Date(Date.now()),
            0,
            [],
            this.new_post.image_url
          )
        );

        this.new_post.content = "";
        this.new_post.image_url = "";
        this.error = "";
      })
      .catch((err) => {
        this.error = err.message;
        console.log(
          "Something went wrong with your new post… Please try again. "
        );
      });
  }
}
